import isNil from 'lodash-es/isNil'

import { EMPTY_LIST } from '../../../constants/common'
import { isEmptyString } from '../../../utils/common'
import { isStaffUser } from '../../../utils/user'
import {
  normalizeEmail,
  splitValidAndInvalidEmails,
  toEmailRecipientFieldSelectItemsFromOption,
} from '../../Email'

function getAppointmentFormParticipantKeys(participant) {
  return [participant.realId, normalizeEmail(participant.email)].filter(Boolean)
}

export function getIsAppointmentFormParticipantExternal(participant) {
  return !isStaffUser(participant)
}

export function getIsAppointmentFormParticipantProfile(participant) {
  return !isNil(participant.realId)
}

export function getIsAppointmentFormParticipantWithoutEmail(participant) {
  return isEmptyString(normalizeEmail(participant.email))
}

export function getHasAppointmentFormInvitee(participants) {
  return participants.some(
    participant =>
      getIsAppointmentFormParticipantExternal(participant) &&
      !getIsAppointmentFormParticipantWithoutEmail(participant)
  )
}

export function getHasAppointmentFormDuplicateParticipant(participants) {
  const keys = participants.flatMap(getAppointmentFormParticipantKeys)

  return new Set(keys).size < keys.length
}

export function getIsAppointmentFormParticipantInputDuplicate({
  input,
  participants,
}) {
  const emails = participants.map(participant =>
    normalizeEmail(participant.email)
  )

  return splitValidAndInvalidEmails(input).valid.some(email =>
    emails.includes(normalizeEmail(email))
  )
}

export function getAppointmentFormOrganizerChips({ t, userData }) {
  return userData
    ? toEmailRecipientFieldSelectItemsFromOption([userData]).map(chip => ({
        ...chip,
        fullname: `${chip.fullname} ${t('Appointment.FormOrganizerMarkKey')}`,
      }))
    : EMPTY_LIST
}

export function getAppointmentFormParticipantDisplayName(participant) {
  return participant.fullname || normalizeEmail(participant.email)
}

export function getAppointmentFormParticipantTagName(participant) {
  if (getIsAppointmentFormParticipantWithoutEmail(participant)) {
    return participant.fullname
  }

  return participant.fullname
    ? `${participant.fullname} <${participant.email}>`
    : participant.email
}

export function getAppointmentFormMockParticipants({ participants, userData }) {
  return [
    {
      display_name: userData?.fullname ?? null,
      email: userData?.email ?? null,
    },
    ...participants.map(participant => ({
      display_name: getAppointmentFormParticipantDisplayName(participant),
      email: normalizeEmail(participant.email) || null,
    })),
  ]
}
